import {
  ChallengeImage,
  ChallengeShell,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Read the English word, pick the matching picture. */
export function WordToImage({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  return (
    <>
      <ChallengeShell
        tag="Word picture"
        prompt={`Pick the picture for "${word.english}"`}
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
      >
        <div className="grid grid-2" style={{ gap: 12, marginTop: 16 }}>
          {choices.map((c) => {
            const correct = c.id === word.id;
            const isPicked = picked === c.id;
            const cls = picked
              ? isPicked
                ? correct
                  ? "good"
                  : "bad"
                : correct
                  ? "good faded"
                  : "faded"
              : "";
            return (
              <button
                key={c.id}
                className={`choice choice-image ${cls}`}
                onClick={() => handle(c)}
                disabled={!!picked}
              >
                <ChallengeImage className="choice-image-img" src={c.imageUrl} alt={c.english} />
              </button>
            );
          })}
        </div>
      </ChallengeShell>
      {teachOverlay}
    </>
  );
}
